import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { isMasterContext } from '../services/authService';

/**
 * Guards screens whose data lives inside a tenant schema.
 *
 * Only an INITIAL_ADMIN can hold a master claim, and every request one of these
 * screens makes would come back 403 TENANT_NOT_SELECTED. Sending them to the
 * picker is the recovery the interceptor would perform anyway — doing it at the
 * route boundary just avoids rendering a screen that is guaranteed to fail.
 *
 * Authentication is already settled by the enclosing ProtectedRoute; this only
 * decides tenancy.
 */
function TenantRoute() {
  return isMasterContext() ? <Navigate to="/select-agency" replace /> : <Outlet />;
}

export default TenantRoute;
